import React, { useEffect, useState } from 'react';
import { getAccountHistory } from '../services/api';

const Charts = () => {
  const [balanceHistory, setBalanceHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await getAccountHistory();
      console.log('📊 Chart API Response:', response.data);
      
      if (response.data.success) {
        const history = response.data.history;
        console.log('📊 History length:', history?.length);
        
        const dailyData = {};
        
        history.forEach(item => {
          const date = new Date(item.created_at).toLocaleDateString();
          if (!dailyData[date]) dailyData[date] = 0;
          if (item.type === 'deposit') dailyData[date] += parseFloat(item.amount);
          if (item.type === 'withdrawal') dailyData[date] -= parseFloat(item.amount);
          if (item.type === 'trade_pnl') dailyData[date] += parseFloat(item.amount);
        });
        
        const last7Days = Object.entries(dailyData).slice(-7);
        console.log('📊 Daily data:', last7Days);
        
        setBalanceHistory(last7Days.map(([date, value]) => ({
          date: date.slice(0, 5),
          value: value
        })));
      }
    } catch (error) {
      console.error('Failed to fetch chart data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="card p-4">
        <div className="h-32 flex items-center justify-center">
          <div className="animate-pulse text-gray-500 text-sm">Loading chart...</div>
        </div>
      </div>
    );
  }

  if (balanceHistory.length === 0) {
    return (
      <div className="card p-4 mb-5">
        <h3 className="text-sm font-semibold text-white mb-3">📊 Net Balance Change</h3>
        <div className="h-32 bg-gray-800/50 rounded-lg flex flex-col items-center justify-center">
          <p className="text-gray-500 text-sm">No transaction data yet</p>
          <p className="text-gray-600 text-xs mt-1">Make a deposit to see your balance history</p>
        </div>
      </div>
    );
  }

  const maxValue = Math.max(...balanceHistory.map(d => Math.abs(d.value)), 1);

  return (
    <div className="card p-4 mb-5">
      <h3 className="text-sm font-semibold text-white mb-3">📊 Net Balance Change (Last 7 days)</h3>
      <div className="relative h-32">
        <div className="absolute inset-0 flex items-end gap-2">
          {balanceHistory.map((day, idx) => (
            <div key={idx} className="flex-1 flex flex-col items-center gap-1">
              <div 
                className={`w-full rounded-t transition-all ${day.value >= 0 ? 'bg-emerald-500/70' : 'bg-red-500/70'}`}
                style={{ height: `${(Math.abs(day.value) / maxValue) * 80}px` }}
              />
              <span className="text-[10px] text-gray-500">{day.date}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-center gap-4 mt-3">
        <span className="flex items-center gap-1 text-[10px] text-gray-400">
          <div className="w-2 h-2 bg-emerald-500 rounded"></div>
          Profit / Deposit
        </span>
        <span className="flex items-center gap-1 text-[10px] text-gray-400">
          <div className="w-2 h-2 bg-red-500 rounded"></div>
          Loss / Withdrawal
        </span>
      </div>
    </div>
  );
};

export default Charts;